// extracted by mini-css-extract-plugin
export default {"infoCardContainer":"gauge-info-card_infoCardContainer__c5p5a","gaugeHeight":"gauge-info-card_gaugeHeight__k3+1f"};